import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Col,
    CardBody,
    FormGroup,
    Input,
    Modal,
    Row,
} from "reactstrap";
import ProductDataService from "../../services/ProductDataService";

class ProductModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          defaultModal: false,
          products: [],
          perPage: 10,
          currentPage: 1,
          currentProduct: {},
          // new state for tabs and stock update
          activeTab: 'edit',
          stockRequest: [],
          errorMessages: [],
          errorMessage: undefined,
        };
        this.productDataService = new ProductDataService();
    }
      
    handleInputChanged(e) {
        let type = e.target.type
        let nam = e.target.name
        let val = e.target.value
        let updateState = true;
        if (type === 'number' || nam === 'warehouse_id') {
            val = Number(e.target.value.toString());
        } else if (nam === 'price' || nam === 'sell_price') {
            if (val.length > 21) {
                this.setErrormessage('Input angka melebihi batas maksimal sistem.')
                setTimeout(() => {
                    this.setState({ errorMessage: undefined });
                }, 5000);
                updateState = false;
            } else {
                val = val.replace(/,/g, '');
                val = Number(val).toLocaleString();
            }
        }
        
        if (updateState) {
            this.setState(prevState => {
                let currentProduct = Object.assign({}, prevState.currentProduct);
                currentProduct[nam] = val;
                return { currentProduct };
            })
        }
    }

    setErrormessage(errorMessage, checkoutDisabled) {
        this.setState({ 
            errorMessage: errorMessage,
            checkoutDisabled: checkoutDisabled,
        })            
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
    }

    handleResponse(data, successMessage) {
        if (data?.data?.errorMessage) {
            this.setState({ errorMessage: data.data.errorMessage })
        } else if (data?.header?.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentProduct: {}})
            this.props.fetchData()
        }
        setTimeout(() => {
            this.setState({ successMessage: undefined, errorMessage: undefined });
        }, 5000);   
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (this.props.formType === 'edit') {
                if (this.state.activeTab === 'stock' && this.canUpdate()) {
                    this.submitUpdateStock();
                } else {
                    this.handleEditProduct();
                }
            } else {
                this.handleAddProduct();
            }
        }
    }
    
    handleAddProduct() {
        let currentProduct = this.state.currentProduct;
        this.cleanCommasFromPrices(currentProduct);
        
        this.productDataService.add(currentProduct)
            .then((data) => {
                this.handleResponse(data, "Produk berhasil ditambahkan");
            })
    }

    handleEditProduct() {
        let currentProduct = this.state.currentProduct;
        this.cleanCommasFromPrices(currentProduct);

        delete currentProduct.warehouse_detail
        delete currentProduct.warehouse_id
        
        this.productDataService.update(currentProduct)
            .then((data) => {
                this.handleResponse(data, "Produk berhasil diubah");
            })
    }

    cleanCommasFromPrices(currentProduct) {
        if (currentProduct['sell_price'] !== undefined 
            && currentProduct['price'] !== undefined 
            && typeof currentProduct['sell_price'] !== 'number' 
            && typeof currentProduct['price'] !== 'number') {
            currentProduct['sell_price'] = Number(currentProduct['sell_price'].replace(/,/g, ''));
            currentProduct['price'] = Number(currentProduct['price'].replace(/,/g, ''));
        }
    }

    onModalOpened() {
        this.setCurrentProduct();
        // set initial tab
        if (this.props.formType === 'edit') {
            this.setState({ activeTab: this.props.initialTab === 'stock' ? 'stock' : 'edit' }, () => {
                if (this.state.activeTab === 'stock') {
                    this.initStockRequestFromProduct();
                }
            });
        } else {
            this.setState({ activeTab: 'edit' });
        }
    }

    onModalClosed() {
        this.setState({ 
            currentProduct: {},
            errorMessages: [],
            stockRequest: [],
            activeTab: 'edit',
         })
    }

    setCurrentProduct() {
        if (this.props.formType === 'edit') {
            this.setState({ currentProduct: this.props.currentProduct })
            this.setState(prevState => {
                let currentProduct = Object.assign({}, prevState.currentProduct)
                currentProduct.current_barcode = currentProduct.product_barcode
                return { currentProduct };
            })
        } else {
            this.setState( { currentProduct : {
                warehouse_id: !((localStorage.getItem("user_roles") || "")
                .split(',')
                .map(role => role.trim().toLowerCase())
                .some(role => role === "admin")) ? Number(localStorage.getItem("warehouse_id")) : null
            }})
        }
    }

    // --- Stock Tab helpers copied from ProductStockUpdateModal (adapted) ---
    handleStockInputChanged = (index, e) => {
        const { name, value } = e.target;
        const updatedStockRequest = [...this.state.stockRequest];
        updatedStockRequest[index][name] = Number(value);
        this.setState({ stockRequest: updatedStockRequest });
    };

    initStockRequestFromProduct() {
        const currentProduct = this.state.currentProduct || {};
        if (!currentProduct.warehouse_detail || currentProduct.warehouse_detail.length === 0) {
            this.setState({ stockRequest: [{ warehouse_id: -1, stock: '' }] });
            return;
        }
        this.setState({
            stockRequest: currentProduct.warehouse_detail.map(detail => ({
                id: detail.id,
                stock: detail.stock,
                warehouse_id: detail.warehouse_id,
            }))
        });
    }

    addStockRequestRow = () => {
        this.setState(prevState => ({
            stockRequest: [...prevState.stockRequest, { warehouse_id: -1, stock: '' }]
        }));
    };

    removeStockRequestRow = (index) => () => {
        this.setState(prevState => {
            const updatedStockRequest = [...prevState.stockRequest];
            updatedStockRequest.splice(index, 1);
            return { stockRequest: updatedStockRequest };
        });
    };

    hasUniqueWarehouses() {
        const warehouseIds = (this.state.stockRequest || []).map(item => item.warehouse_id);
        const uniqueWarehouseIds = new Set(warehouseIds);
        return warehouseIds.length === uniqueWarehouseIds.size;
    }

    validStockRequest() {
        return (this.state.stockRequest || []).every(item =>
            item.warehouse_id != null && item.warehouse_id !== '' && item.warehouse_id != -1 &&
            item.stock != null && item.stock !== ''
        );
    }

    canUpdate() {
        return (this.isAdmin() || (this.state.stockRequest || []).some(req => req.warehouse_id == localStorage.getItem("warehouse_id")))
            && this.validStockRequest() && this.hasUniqueWarehouses();
    }

    isAdmin() {
        return ((localStorage.getItem("user_roles")) || "")
            .split(',')
            .map(role => role.trim().toLowerCase())
            .some(role => role === "admin");
    }

    canUpdateStock(warehouse_id) {
        return (((localStorage.getItem("user_roles")) || "")
            .split(',')
            .map(role => role.trim().toLowerCase())
            .some(role => role === "admin") || warehouse_id == localStorage.getItem("warehouse_id"))
    }

    submitUpdateStock() {
        const { currentProduct, stockRequest } = this.state;
        this.productDataService.updateStock(currentProduct.product_id, stockRequest)
            .then((data) => {
                this.handleResponse(data, "Stock berhasil diupdate");
            })
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
                >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent">
                        <div className="text-muted text-center mt-2 mb-3">
                            <h3 className="mb-0">{this.props.formType === 'add' ? 'Tambah produk baru' : (this.state.activeTab === 'stock' ? 'Ubah Stock produk' : 'Ubah produk') }</h3>
                            {this.props.formType === 'edit' && (
                                <div className="mt-3">
                                    <Button color={this.state.activeTab === 'edit' ? 'primary' : 'secondary'} size="sm" type="button" onClick={() => this.setState({ activeTab: 'edit' })}>
                                        Ubah
                                    </Button>
                                    {(!!this.state.currentProduct?.warehouse_detail && (((localStorage.getItem("user_roles")||"").split(',').map(r=>r.trim().toLowerCase()).includes('admin')) || ((localStorage.getItem("user_roles")||"").split(',').map(r=>r.trim().toLowerCase()).includes('cashier')))) && (
                                        <Button className="ml-2" color={this.state.activeTab === 'stock' ? 'primary' : 'secondary'} size="sm" type="button" onClick={() => { this.setState({ activeTab: 'stock' }, () => this.initStockRequestFromProduct()); }}>
                                            Ubah Stock
                                        </Button>
                                    )}
                                </div>
                            )}
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        {this.state.errorMessages && this.state.errorMessages.map((errorMessage) => (
                            <Alert color="danger">
                            {errorMessage}
                            </Alert>
                        ))}
                        {this.state.errorMessage && (
                            <Alert color="danger">
                            {this.state.errorMessage}
                            </Alert>
                        )}
                        {this.state.activeTab !== 'stock' && (<div>
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-barcode"
                            >
                                Bacode produk
                            </label>
                            <Input placeholder="Barcode produk"
                            className="form-control-alternative"
                            name="product_barcode"
                            id="input-barcode"
                            value={this.state.currentProduct?.product_barcode}
                            onChange={this.handleInputChanged.bind(this)}
                            onKeyUp={this.onKeyUp.bind(this)}
                            type="text" />
                        </FormGroup>
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-supplier"
                            >
                                Supplier produk
                            </label>
                            <Input placeholder="Supplier produk"
                            name="supplier"
                            className="form-control-alternative"
                            value={this.state.currentProduct?.supplier}
                            onChange={this.handleInputChanged.bind(this)}
                            onKeyUp={this.onKeyUp.bind(this)}
                            type="text" />
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Row>
                            <Col lg={this.props.formType === 'add' ? '6' : '12'}>
                                <label
                                className="form-control-label"
                                htmlFor="input-name"
                                >
                                Nama produk
                                </label>
                                <Input placeholder="Nama produk"
                                    name="product_name"
                                    className="form-control-alternative"
                                    value={this.state.currentProduct?.product_name}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                            </Col>
                            {(this.props.formType === 'add') && (
                                <Col lg="6">
                                    <label
                                    className="form-control-label"
                                    htmlFor="input-stock"
                                    >
                                    Stok produk
                                    </label>
                                    <Input placeholder="Stok produk"
                                        name="product_stock"
                                        className="form-control-alternative"
                                        value={this.state.currentProduct?.product_stock}
                                        onChange={this.handleInputChanged.bind(this)}
                                        onKeyUp={this.onKeyUp.bind(this)}
                                        type="number" />
                                </Col>
                            )}
                            </Row>
                        </FormGroup>
                        {(this.props.formType === 'add') && (
                            <FormGroup>
                                <Row>
                                    <Col lg="12">
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-stock"
                                        >
                                        Warehouse produk
                                        </label>
                                        <Input
                                            placeholder="Warehouse produk"
                                            name="warehouse_id"
                                            type="select"
                                            value={this.state.currentProduct.warehouse_id}
                                            onChange={this.handleInputChanged.bind(this)}
                                            disabled={!((localStorage.getItem("user_roles") || "")
                                                .split(',')
                                                .map(role => role.trim().toLowerCase())
                                                .some(role => role === "admin"))}>
                                            <option value='-1'>Warehouse produk</option>
                                            {this.props.warehouses.map(warehouse => (
                                                <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                                                    {warehouse.warehouse_name}
                                                </option>
                                            ))}
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>
                        )}
                        <FormGroup>
                            <Row>
                            <Col lg="6">
                                <label
                                className="form-control-label"
                                htmlFor="input-price"
                                >
                                Harga produk
                                </label>
                                <Input placeholder="Harga produk"
                                    name="price"
                                    className="form-control-alternative"
                                    value={this.state.currentProduct?.price}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                            </Col>
                            <Col lg="6">
                                <label
                                className="form-control-label"
                                htmlFor="input-sell-price"
                                >
                                Harga jual produk
                                </label>
                                <Input placeholder="Harga jual produk" 
                                    name="sell_price"
                                    className="form-control-alternative"
                                    value={this.state.currentProduct?.sell_price}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                            </Col>
                            </Row>
                        </FormGroup>
                        </div>)}
                        {this.state.activeTab === 'stock' && (
                          <div>
                            <FormGroup className="mb-3">
                              <Row>
                                <Col lg="6">
                                  <label className="form-control-label" htmlFor="stock-barcode">Bacode produk</label>
                                  <Input id="stock-barcode" className="form-control-alternative" value={this.state.currentProduct?.product_barcode} disabled type="text" />
                                </Col>
                                <Col lg="6">
                                  <label className="form-control-label" htmlFor="stock-name">Nama produk</label>
                                  <Input id="stock-name" className="form-control-alternative" value={this.state.currentProduct?.product_name} disabled type="text" />
                                </Col>
                              </Row>
                            </FormGroup>
                            <FormGroup>
                              {!this.hasUniqueWarehouses() && (
                                <Alert color="warning">Warehouse tujuan tidak boleh sama.</Alert>
                              )}
                              {this.state.stockRequest?.map((req, index) => (
                                <Row key={index} className="mb-3">
                                  <Col lg="6">
                                    <label className="form-control-label" htmlFor={`warehouse-${index}`}>Warehouse #{index + 1}</label>
                                    <Input id={`warehouse-${index}`} placeholder="Pilih warehouse" name="warehouse_id" type="select" value={req.warehouse_id} onChange={e => this.handleStockInputChanged(index, e)}>
                                      <option value='-1' disabled>Pilih warehouse</option>
                                      {this.props.warehouses.map(warehouse => (
                                        <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>{warehouse.warehouse_name}</option>
                                      ))}
                                    </Input>
                                  </Col>
                                  <Col lg="2">
                                    <label className="form-control-label" htmlFor={`stock-${index}`}>Stock</label>
                                    <Input id={`stock-${index}`} placeholder="Stock" name="stock" type="number" value={req.stock} disabled={!this.canUpdateStock(req.warehouse_id)} onChange={e => this.handleStockInputChanged(index, e)} />
                                  </Col>
                                  <Col lg="4">
                                    <label className="form-control-label" htmlFor={`aksi-${index}`}>Aksi</label>
                                    <div className="btn-wrapper">
                                      {index !== 0 && (<Button color="danger" type="button" onClick={this.removeStockRequestRow(index)}>Hapus</Button>)}
                                      <Button color="primary" type="button" onClick={this.addStockRequestRow}>Tambah</Button>
                                    </div>
                                  </Col>
                                </Row>
                              ))}
                            </FormGroup>
                          </div>
                        )}
                        <FormGroup>
                            <div className="btn-wrapper text-right">
                            <Button
                                className="my-4"
                                color="secondary"
                                type="button"
                                onClick={this.props.toggleModal}
                                >
                                Batal
                            </Button>
                            <Button
                                className="my-4"
                                color="primary"
                                type="button"
                                disabled={this.props.formType !== 'add' && this.state.activeTab === 'stock' && !this.canUpdate()}
                                onClick={() => this.props.formType === 'add' ? this.handleAddProduct() : (this.state.activeTab === 'stock' ? this.submitUpdateStock() : this.handleEditProduct())}
                                >
                                Simpan
                            </Button>
                            </div> 
                        </FormGroup> 
                    </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default ProductModal;
